import { NewsThumbnail } from 'ui/components';
import { NewsFetcher } from './NewsFetcher';

export const NewsThumbnailFeature: React.FC<Umbraco.NewsThumbnail> = ({ content }) => (
	<NewsThumbnail {...content?.properties} newsFetcher={NewsFetcher} />
);
